"use client";
import { Breadcrumbs, BreadcrumbItem } from "@nextui-org/react";
import Link from "next/link";

const CustomBreadcrumbs = ({ text }) => {
  return (
    <Breadcrumbs
      classNames={{
        list: "bg-transparent",
        separator: "text-muted-foreground",
      }}
    >
      <BreadcrumbItem>
        <Link
          href="/"
          className="text-brand-deep hover:text-brand-sky transition-colors font-medium"
        >
          Home
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem
        classNames={{
          item: "text-brand-navy font-semibold capitalize",
        }}
      >
        {text}
      </BreadcrumbItem>
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;